var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('profileParts'),_c('a',{staticClass:"flix-btn flix-btn-default",attrs:{"href":_vm.link.url,"target":"_blank"}},[_c('flixIcon',{attrs:{"id":"share"}}),_vm._v(" "+_vm._s(_vm.$t('message.goTo', { name: _vm.$t('message.dataCenter') })))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }